import { NavLink } from "react-router-dom"
import { Map, Route, Calendar, DollarSign, Fuel, Settings, HelpCircle } from "lucide-react"
import { cn } from "@/lib/utils"
import ezerLogo from "@/assets/ezer-logo.png"

const navItems = [
  { icon: Map, label: "Explore", path: "/" },
  { icon: Route, label: "Shift Planner", path: "/shift" },
  { icon: Calendar, label: "Events", path: "/events" },
  { icon: DollarSign, label: "Earnings", path: "/earnings" },
  { icon: Fuel, label: "Fuel & Charging", path: "/fuel" },
]

const bottomItems = [
  { icon: Settings, label: "Settings", path: "/settings" },
  { icon: HelpCircle, label: "Help", path: "/help" },
]

function SidebarLink({ item }: { item: { icon: React.ElementType; label: string; path: string } }) {
  return (
    <li>
      <NavLink
        to={item.path}
        className={({ isActive }) =>
          cn(
            "flex items-center gap-3 px-3 py-2.5 rounded-lg",
            "text-sm text-muted-foreground",
            "transition-colors duration-150",
            "hover:text-foreground hover:bg-accent",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-card",
            isActive && "text-foreground bg-muted font-medium"
          )
        }
      >
        <item.icon className="h-5 w-5 shrink-0" aria-hidden="true" />
        <span>{item.label}</span>
      </NavLink>
    </li>
  )
}

export function DesktopSidebar() {
  return (
    <aside className="hidden md:flex flex-col w-60 border-r bg-card h-screen sticky top-0">
      {/* Logo */}
      <div className="flex items-center gap-3 px-4 py-4 border-b">
        <img
          src={ezerLogo}
          alt="Ezer"
          className="h-12 w-12 rounded-xl object-contain dark:brightness-0 dark:invert"
        />
        <div>
          <h1 className="font-bold text-xl leading-tight tracking-tight">Ezer</h1>
          <p className="text-xs text-muted-foreground leading-tight">Driver Intelligence</p>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="flex-1 px-3 py-4" role="navigation" aria-label="Main navigation">
        <ul className="space-y-1">
          {navItems.map((item) => (
            <SidebarLink key={item.path} item={item} />
          ))}
        </ul>
      </nav>

      {/* Bottom Navigation */}
      <div className="px-3 py-3 border-t" role="navigation" aria-label="Settings navigation">
        <ul className="space-y-1">
          {bottomItems.map((item) => (
            <SidebarLink key={item.path} item={item} />
          ))}
        </ul>
      </div>
    </aside>
  )
}
